import Loader from '@web-ui-kit/loader'

import * as Sc from './LoaderFullScreen.styles'

const LoaderFullScreen = () => {
  return (
    <Sc.LoaderFullScreenContainer>
      <Loader />
    </Sc.LoaderFullScreenContainer>
  )
}

export default LoaderFullScreen
